import { Inject, Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { Oauth2Provider } from '../../../models/provider.model';
import { DefaultResponse } from '../../../interfaces/responses';
import { ApiService } from '../../shared/services/api.service';
import { endpoints } from '../../../../environments/endpoints';
import { TokenStorageService } from './token-storage.service';

export interface TokenResponse {
  accessToken: string;
  refreshToken: string;
}

export interface RefreshResponse {
  accessToken: string;
}

export interface ChangeUserRequest {
  igg: string;
}

export interface ChangeUserResponse {
  redirectUrl: string;
}

@Injectable({
  providedIn: 'root',
})
export class Oauth2Service {
  private readonly _apiService = inject(ApiService);
  private readonly _tokenStorage = inject(TokenStorageService);

  constructor(
    @Inject('OAUTH2_PROVIDERS_URL') private readonly _oauth2ProvidersUrl: string
  ) {}

  fetchToken(uniqueCode: string): Observable<TokenResponse> {
    this._validateRequiredParam(uniqueCode, 'Unique code is required');
    return this._apiService.get<TokenResponse>(`${endpoints.token}/${uniqueCode}`);
  }

  getProviders(): Observable<Oauth2Provider[]> {
    return this._apiService.get<DefaultResponse<Oauth2Provider[]>>(this._oauth2ProvidersUrl).pipe(
      map(response => response?.data || [])
    );
  }

  refreshToken(): Observable<RefreshResponse> {
    return this._apiService.post<RefreshResponse, Record<string, never>>(endpoints.refreshToken, {});
  }

  changeUser(request: ChangeUserRequest): Observable<ChangeUserResponse> {
    this._validateRequiredParam(request?.igg, 'User IGG is required');
    return this._apiService.post<ChangeUserResponse, ChangeUserRequest>(endpoints.changeUser, request);
  }


  isAuthenticated(): boolean {
    return !this._tokenStorage.isAccessTokenExpired();
  }

  getTokenInfo() {
    return this._tokenStorage.getTokenInfo();
  }

  private _validateRequiredParam(value: string | undefined, errorMessage: string): void {
    if (!value?.trim()) {
      throw new Error(errorMessage);
    }
  }
}
